"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ui = require("@unite-us/ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Display = function Display(_ref) {
  var afterLabelContent = _ref.afterLabelContent,
    disabled = _ref.disabled,
    id = _ref.id,
    label = _ref.label,
    onEditClick = _ref.onEditClick,
    value = _ref.value;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-inline-edit-field__display ui-inline-display"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-inline-display__container"
  }, /*#__PURE__*/_react["default"].createElement("h5", null, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-inline-display__after-label-content"
  }, afterLabelContent), /*#__PURE__*/_react["default"].createElement("span", null, value)), !disabled && /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-inline-display__control"
  }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
    icon: "IconPencil",
    onClick: onEditClick,
    id: "".concat(id, "-edit-btn"),
    color: "white",
    ariaLabel: "Edit",
    size: 18
  })));
};
Display.propTypes = {
  afterLabelContent: _propTypes["default"].node,
  disabled: _propTypes["default"].bool.isRequired,
  id: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  onEditClick: _propTypes["default"].func.isRequired,
  value: _propTypes["default"].string.isRequired
};
Display.defaultProps = {
  afterLabelContent: null
};
var _default = exports["default"] = Display;